export default __webpack_public_path__ + "static/media/xls.31aece20.svg";